import { getMomentTz } from "@dexteel/mesf-core";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { Box, Button, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { SawEntryProduct } from "../models/types";
import { ScanEntryBundleModal } from "./ScanEntryBundleModal";
import {
	CardBodySx,
	CardPaperSx,
	CardTitle,
	IdentityRows,
	InfoGrid,
	SAW_ACCENT,
} from "./primitives";

const moment = getMomentTz();

type Props = {
	data?: SawEntryProduct | null;
	// Real saw AssetId; null disables the Scan button until the catAsset is wired.
	assetId?: number | null;
	// Called after a scan persists, so the page can refetch the overview.
	onScanned?: () => void;
	onError?: (e: Error) => void;
};

export const EntryProductCard = ({
	data = null,
	assetId = null,
	onScanned,
	onError,
}: Props) => {
	const [scanOpen, setScanOpen] = useState(false);

	const scannedSub = data?.scannedAt
		? `Scanned ${moment(data.scannedAt).format("MM/DD HH:mm")}`
		: undefined;

	return (
		<Paper elevation={1} sx={CardPaperSx}>
			<CardTitle
				title="Entry Product"
				action={
					<Button
						size="small"
						variant="contained"
						color="primary"
						startIcon={<QrCodeScannerIcon />}
						disabled={assetId == null}
						onClick={() => setScanOpen(true)}
					>
						Scan Tag
					</Button>
				}
			/>

			<Box sx={CardBodySx}>
				<IdentityRows
					accent={SAW_ACCENT}
					rows={[
						{
							label: "Entry Bundle Tag Number",
							value: data?.bundleId,
							aside: scannedSub ? (
								<Typography
									sx={{
										fontSize: "0.68rem",
										color: "#5f6b7a",
										whiteSpace: "nowrap",
									}}
								>
									{scannedSub}
								</Typography>
							) : undefined,
						},
					]}
				/>

				<InfoGrid
					items={[
						{ label: "Part #", value: data?.partNumber ?? null, span: true },
						{
							label: "Extended Part #",
							value: data?.extendedPartNumber ?? null,
							span: true,
						},
						{ label: "Section", value: data?.section ?? null },
						{ label: "Grade", value: data?.grade ?? null },
						{
							label: "Pieces",
							value: data?.pieces != null ? String(data.pieces) : null,
						},
						{
							label: "Length",
							value:
								data?.bundleLength != null ? String(data.bundleLength) : null,
						},
						{ label: "Heat #", value: data?.heatNo ?? null, span: true },
					]}
				/>
			</Box>

			<ScanEntryBundleModal
				open={scanOpen}
				assetId={assetId}
				onClose={() => setScanOpen(false)}
				onScanned={onScanned}
				onError={onError}
			/>
		</Paper>
	);
};
